import { DirectPhoneCallGatewayStrategy } from 'components/phoneCall/phoneCallGateway/DirectPhoneCallGatewayStrategy';

import { AbstractDirectPhoneCallGatewayStrategy } from 'src/components/phoneCall/phoneCallGateway/AbstractDirectPhoneCallGatewayStrategy';

import { CommandBus } from 'src/util/command/CommandBus';
import { isFirefox } from 'src/util/platform';

export class CallToDirectPhoneCallGatewayStrategy
	extends AbstractDirectPhoneCallGatewayStrategy
	implements DirectPhoneCallGatewayStrategy
{
	constructor(commandBus: CommandBus, authenticatedUserId: number) {
		super(commandBus, authenticatedUserId);
	}

	public async makeCall(callerName: string, toNumber: string): Promise<null | string> {
		if (isFirefox()) {
			window.location.href = `callto:${toNumber}`;
		} else {
			window.open(`callto:${toNumber}`, '_system');
		}

		return await this.createPhoneCall(callerName, toNumber);
	}
}
